import { createFileRoute } from "@tanstack/react-router";

import { FeedbackSettingsPanel } from "../components/settings/FeedbackSettings";
import { redirectUnlessOfferedOnClient } from "../components/settings/settingsClientBridges";

export const Route = createFileRoute("/settings/feedback")({
  // Reachable wherever the Connect bridge is, signed in or not: the sign-in gates submitting a
  // report, not finding out that reporting one needs an account (#808).
  beforeLoad: () => redirectUnlessOfferedOnClient("/settings/feedback"),
  component: FeedbackSettingsPanel,
});
